module.exports = __webpack_public_path__ + "img/1722_candypink.0bf26ba7.jpg";